import { cn } from "@/lib/utils";

/**
 * Used for pages that will not use the full width of the page, such as recipes or learn pages.
 */
export function ContainerSmall({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("mx-auto max-w-5xl", className)}>{children}</div>;
}
